"use client"

import {
  RadialBarChart as RRadialBarChart, RadialBar, Tooltip, Legend, ResponsiveContainer,
} from "recharts"
import {
  type ChartDatum, type ChartDimension, DEFAULT_PALETTE, colorFor,
} from "./types"
import type { CSSProperties } from "react"

export interface RadialBarChartProps {
  data: ChartDatum[]
  /** Field that holds the bar's value. */
  valueKey?: string
  /** Field that holds the bar's label. */
  nameKey?: string
  palette?: string[]
  colorMap?: Record<string, string>
  innerRadius?: number | string
  outerRadius?: number | string
  startAngle?: number
  endAngle?: number
  /** Render a translucent track behind each bar. */
  withBackground?: boolean
  showLegend?: boolean
  showTooltip?: boolean
  className?: string
  style?: CSSProperties
  height?: ChartDimension
  width?: ChartDimension
}

export function RadialBarChart({
  data, valueKey = "value", nameKey = "name",
  palette = DEFAULT_PALETTE, colorMap,
  innerRadius = "20%", outerRadius = "90%", startAngle = 90, endAngle = -270,
  withBackground = true, showLegend = true, showTooltip = true,
  className, style, height = "100%", width = "100%",
}: RadialBarChartProps) {
  const decorated = data.map((d, i) => ({ ...d, fill: colorFor(String(d[nameKey] ?? i), i, palette, colorMap) }))
  return (
    <ResponsiveContainer width={width} height={height} className={className} style={style}>
      <RRadialBarChart data={decorated} innerRadius={innerRadius} outerRadius={outerRadius} startAngle={startAngle} endAngle={endAngle}>
        <RadialBar background={withBackground} dataKey={valueKey} isAnimationActive={false} />
        {showTooltip && <Tooltip cursor={{ fill: "hsl(var(--foreground) / 0.06)", stroke: "hsl(var(--muted-foreground))", strokeOpacity: 0.35 }} contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 6, fontSize: 11, color: "hsl(var(--card-foreground))" }} />}
        {showLegend && <Legend wrapperStyle={{ fontSize: 11 }} />}
      </RRadialBarChart>
    </ResponsiveContainer>
  )
}
